export const poolGroupOptions = (t) => [
  { name: t("Dejoyaux"), code: "Dejoyaux" },
  { name: t("Piscine Ibiza"), code: "Piscine Ibiza" },
  { name: t("Piscine de France"), code: "Piscine de France" },
  { name: t("Aboral Piscine"), code: "Aboral Piscine" },
  { name: t("Alliance Piscines"), code: "Alliance Piscines" },
  { name: t("Aquilius Piscines"), code: "Aquilius Piscines" },
  { name: t("Bel'O Piscine"), code: "Bel'O Piscine" },
  { name: t("Blue Lagoon Spas"), code: "Blue Lagoon Spas" },
  { name: t("Caron Piscines"), code: "Caron Piscines" },
  { name: t("Cocktail Piscine"), code: "Cocktail Piscine" },
  { name: t("EuroPiscine"), code: "EuroPiscine" },
  { name: t("Irripiscine"), code: "Irripiscine" },
  { name: t("Hydrosud"), code: "Hydrosud" },
  { name: t("L'eau bien être"), code: "L'eau bien être" },
  { name: t("L'esprit Piscine"), code: "L'esprit Piscine" },
  { name: t("Fusion Piscine"), code: "Fusion Piscine" },
  { name: t("Mondial Piscine"), code: "Mondial Piscine" },
  { name: t("Neptune Piscines"), code: "Neptune Piscines" },
  { name: t("Oasis Piscines"), code: "Oasis Piscines" },
  { name: t("Carré Bleu"), code: "Carré Bleu" },
  { name: t("Magiline"), code: "Magiline" },
  { name: t("Solid Pool"), code: "Solid Pool" },
];

export const annualSpaPotentialOptions = [
  {
    name: "0-5",
    code: "0-5",
  },
  {
    name: "6-15",
    code: "6-15",
  },
  {
    name: "16-24",
    code: "16-24",
  },
  {
    name: "25-40",
    code: "25-40",
  },
  {
    name: "+41",
    code: "41",
  },
];

export const elements = [
  {
    type: "select",
    label: "Status",
    name: "status",
    placeholder: "Status",
    resetable: true,
    showClear: true,
  },
  {
    type: "date",
    label: "Reminder date",
    name: "followUpDate",
    placeholder: "Reminder date",
    minDate: false,
  },
  {
    type: "select",
    label: "Area",
    name: "area",
    placeholder: "Area",
    resetable: true,
    showClear: true,
  },
  {
    type: "select",
    label: "Country",
    name: "country",
    placeholder: "Country",
    resetable: true,
    showClear: true,
  },
  {
    type: "select",
    label: "Potential Spa/year",
    name: "annualSpaPotential",
    placeholder: "Potential Spa/year",
    resetable: true,
    showClear: true,
  },
  {
    type: "multiselect",
    label: "Spa Marque",
    name: "spaMarques",
    placeholder: "Spa Marque",
    appendTo: "self",
    filter: true,
    resetable: true,
    showClear: true,
  },
  {
    type: "select",
    label: "Pool/Spa Group",
    name: "poolSpaGroup",
    placeholder: "Pool/Spa Group",
    resetable: true,
    showClear: true,
  },
];
